import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  margin: 0 5rem;
  img {
    height: 60%;
    width: 60%;
  }
  .searchbar {
    // justify-self: center;
    img {
      position: absolute;
    }
    i {
      position: absolute;
    }
    input[type=search] {
      background-color: hsla(0,0%,100%,.05098);
      color: #a0a4a7;
      height: 30px;
      width: 300px;
      border-radius: 10px;
      padding: 1rem;
    }
  }
  .connect-wallet {
    display: grid;
    justify-items: center;
    color: #fff;
    button {
      cursor: pointer;
      height: 3rem;
      width: 10rem;
      color: #fff;
      // background-color: darkorange;
      border-radius: 10px;
    }
    .dropdown-menu {
      .dropdown-item {
        display: grid;
        grid-template-columns: 20% auto;
        align-items: center;
        justify-content: start;
        justify-items: center;
        padding: .5rem;
        img {
          max-height: 100%;
          max-width: 100%;
        }
      }
    }
  }
  .wallet-selection {
    padding: 5rem;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    display: grid;
    grid-template-columns: auto;
    gap: 2rem;
    width: 35vw;
    height: 30vh;
    background-color: #14181d;
    position: fixed;
    z-index: 1;
    border-radius: 1rem;
    background-image: conic-gradient(red, yellow, green);
    button {
      color: #000;
      background-color: rgb(0, 163, 242);
      &:hover {
        background-color: #f1b354;
      }
    }
    .wallets {
      display: grid;
      grid-template-columns: auto auto;
      gap: 1rem;
      align-content: center;
      justify-content: space-around;
    }
    .cancel {
      display: grid;
      justify-content: center;
    }
  }
  
  @media all and (max-width: 575px) {
    margin: 0 1rem;
    grid-template-columns: auto auto auto auto 125px;
    #bannerlogo {
      display: none !important;
    }
    .connect-wallet {
      span {
        display:none;
      }
      button {
        width:123px !important;
      }
    }
  }
`;